export default __webpack_public_path__ + "static/media/Tree_Hex.c031b2a5.svg";